import React, { useCallback, useMemo, useState } from 'react';

import { Modal } from '@/components';
import { SuccessModal } from '@/components/elements';

import { ScheduledReportItemPayload, ScheduledReportPayload } from '../ScheduledReport.types';
import ScheduledReportSetup from '../ScheduledReportSetup';
export interface Props extends ScheduledReportItemPayload {
  visible: boolean;
  onSetVisible: (value: boolean) => void;
}
const ScheduledReportItemEditModal: React.FC<Props> = ({ visible, onSetVisible, ...payload }) => {
  const [isSuccessModal, setSuccessModal] = useState(false);
  const [isPreviewShowed, setPreviewShowed] = useState(false);
  const bridgeData = useMemo(() => {
    const result: ScheduledReportPayload = {
      id: payload.id,
      cronString: payload.cron,
      name: payload.name,
      startDate: payload.startDate || '',
      endDate: payload.endDate || '',
      tab: payload.reportGroupType,
      type: payload.reportType,
      filterValues: payload.reportFilter,
    };
    return result;
  }, [
    payload.cron,
    payload.endDate,
    payload.id,
    payload.name,
    payload.reportFilter,
    payload.reportGroupType,
    payload.reportType,
    payload.startDate,
  ]);
  const handleSuccess = useCallback(() => {
    setSuccessModal(true);
    onSetVisible(false);
  }, [onSetVisible]);
  return (
    <>
      <SuccessModal
        visible={isSuccessModal}
        header="Schedule has been successfully updated!"
        onSetVisible={() => setSuccessModal(false)}
        buttonText="Got it!"
      />
      <Modal
        testId="edit-scheduled-report"
        maxWidth={isPreviewShowed ? '880px' : undefined}
        visible={visible}
        onSetVisible={onSetVisible}
      >
        <ScheduledReportSetup
          onSetPreviewShowed={setPreviewShowed}
          {...bridgeData}
          isEditMode
          onClose={() => onSetVisible(false)}
          onSuccess={handleSuccess}
        />
      </Modal>
    </>
  );
};
export default ScheduledReportItemEditModal;
